import React from "react";
import { Entry } from "contentful";

import { Page } from "@trailhead/contentful"

import { CustomSectionDemo } from "./components/customSections"
import { updateMxHeader } from "@trailhead/mx-header";
import { useMxContext } from "@trailhead/mx-context";
import { HeaderState } from "@soluto-private/mx-app-header";
import { useSanitizedTranslation } from "@trailhead/i18n";

type Props = {
    mxHeaderOverride?: Partial<HeaderState>,
    page: Entry<Page>,
}

export const PageBuilder = ({ mxHeaderOverride, page }: Props): JSX.Element => {
    const { client } = useMxContext();
    const t = useSanitizedTranslation();

    updateMxHeader({
        view: mxHeaderOverride?.view || "service-view",
        client,
        subNavConfig: {
            title: page.fields.title || t('Mobile Device Set Up'),
            ...mxHeaderOverride?.subNavConfig,
        }
    });

    return (
        <>
            {page.fields.sections.map((sectionProps) => <CustomSectionDemo {...sectionProps} />)}
        </>
    );
}
